import React, { useState } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { setCurrentStep, setShowPopUp, setSelectedActionType, setSelectedActionSubType } from '../OwnershipTransferSlice';
import SelectOptionButton from '../../../Shared/SelectOptionButton/SelectOptionButton';
import { OwnershipTransferStep, OwnershipTransferActionType, OwnershipTransferActionSubType } from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'

const SelectActionType = (props) => {
  const [error, setError] = useState(false);
  const buttons = [
    {
      id: '0',
      label: 'העברת בעלות מפרטי לעסקי',
      value: OwnershipTransferActionType.PrivateToBusiness,
      selected: props.data.selectedActionType === OwnershipTransferActionType.PrivateToBusiness ? true : false,
    },
    {
      id: '1',
      label: 'העברת בעלות מהעסקי לפרטי',

      value: OwnershipTransferActionType.BusinessToPrivate,
      selected: props.data.selectedActionType === OwnershipTransferActionType.BusinessToPrivate ? true : false,
      subSelecting: props.data.jetConnection ? true : false,
      subSelectingData: [
        {
          id: '0',
          label: 'העברת מנוי בודד',
          value: OwnershipTransferActionSubType.SingleTransfer,
          selected: props.data.selectedActionSubType === OwnershipTransferActionSubType.SingleTransfer ? true : false,
        },
        {
          id: '1',
          label: 'העברה גורפת',
          value: OwnershipTransferActionSubType.BulkTransfer,
          selected: props.data.selectedActionSubType === OwnershipTransferActionSubType.BulkTransfer ? true : false,
        },
      ]
    },
    {
      id: '2',
      label: 'העברת בעלות מימון מלא למפוצל',
      value: OwnershipTransferActionType.FullFundingToSeparate,
      selected: props.data.selectedActionType === OwnershipTransferActionType.FullFundingToSeparate ? true : false,
    },
  ];

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock },
        actionType: DwhActionType.OwnershipTypePage,
        messageText: DWHMessageText.OwnershipTypePageDisplayed,
        status: DWHStatus.Ongoing,
      });
    }
  }, []);

  function setSubSelecting(buttonValue, subButtonValue) {
    props.setSelectedActionSubType(subButtonValue);

  }

  function nextStep() {
    if (!props.data.selectedActionType) {
      setError(true);
    }
    else if (props.data.jetConnection && props.data.selectedActionType === OwnershipTransferActionType.BusinessToPrivate && !props.data.selectedActionSubType) {
      setError(true);

    } else {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock },
        actionType: DwhActionType.OwnershipTypePage,
        messageText: DWHMessageText.OwnershipTypePageButtonClicked,
        status: DWHStatus.Ongoing,
      });
      if (props.data.jetConnection && props.data.selectedActionType === OwnershipTransferActionType.BusinessToPrivate && props.data.selectedActionSubType === OwnershipTransferActionSubType.BulkTransfer) {
        props.setCurrentStep(OwnershipTransferStep.ContactPersonForm);
      }
      else {
        props.setCurrentStep(OwnershipTransferStep.ValidateCustomer);
      }

    }
  }

  return (
    <div className='ownership-transfer-select-action-type ownership-transfer-step'>
      {props.data.jetConnection && <div className='l-title regular'>שלום {props.userDetails.userName}</div>}
      <div className='l-title '>העברת בעלות ופיצול</div>
      <div className='stepContainer'>
        <div className=''>
          <SelectOptionButton title={'מה סוג ההעברה?'} buttonsData={buttons} onClick={props.setSelectedActionType} onSubButtonClick={setSubSelecting} />
        </div>
      </div>
      {isMobile && (
        <div className='dashboard-message'>
          בשביל לראות סטאטוס העברת בעלות,
          <br />
          יש להיכנס לתהליך דרך המחשב
        </div>
      )}
      <div className='continue-button'>
        {error && <div className='error center'>כדי להמשיך יש לבחור את סוג הפעולה</div>}
        <BtnSubmit onclick={nextStep} text={'בחרתי, אפשר להמשיך'} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  userDetails: state.authentication?.loginData?.userDetails,
  portalsBlock: state.portalsBlock,
});

const mapDispatchToProps = {
  setCurrentStep,
  setSelectedActionType,
  setSelectedActionSubType
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectActionType);
